import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import ProSubscriptionsTable from "components/Doobi/ProSubscriptions";

const ProSubscriptionsRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Pro Subscriptions" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={ProSubscriptionsTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default ProSubscriptionsRoute;
